export enum CommonLoggerEventName {
  PageView = 'page_view',
}
